import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'

import adminSelectors from 'store/selectors/admin'
import adminActions from 'store/modules/admin'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
  buttons: {
    marginTop: theme.spacing(4),
  },
  footer: {
    marginTop: theme.spacing(4),
  },
  results: {
    marginTop: theme.spacing(4),
    border: '1px solid #ccc',
    padding: theme.spacing(2),
    fontFamily: 'Courier',
    fontSize: '0.8em',
    color: '#666'
  }
}))

const UpdateConfigs = ({

}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  
  const result = useSelector(adminSelectors.updateConfigsResult)

  const onSubmit = useCallback((payload) => {
    dispatch(adminActions.updateConfigs())
  })

  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
        <Typography gutterBottom variant="h6">
          Update Configs
        </Typography>
        <Typography gutterBottom variant="body1">
          Click the button below to update configs from the config repo.
        </Typography>
        <Typography gutterBottom variant="body1">
          This will update all projects that have booking forms with the config path field set.
        </Typography>
        <Button
          color="primary"
          variant="contained"
          onClick={ onSubmit }
        >
          Update Configs
        </Button>
        {
          result && (
            <div className={ classes.results }>
              <pre>
                { result }
              </pre>
            </div>
          )
        }
      </Paper>
    </div>
  )
}

export default UpdateConfigs